export default __webpack_public_path__ + "static/desk02-66f10d3e7b3347a7d86e788b2482a704.png";